<div class="logo-wrapper">
  <span class="logo">BG Fashion</span>
</div>

<div *ngIf="!isMobile" class="links-wrapper">
  <div class="links-list">
    <span class="title">General</span>
    <a *ngFor="let generalLink of generalLinks" class="link" [routerLink]="generalLink.linkUrl" routerLinkActive="is-active">
      <span>{{ generalLink.title }}</span>
    </a>
  </div>

  <div class="links-list">
    <span class="title">Social</span>
    <a *ngFor="let socialLink of socialLinks" class="link" [href]="socialLink.linkUrl" target="_blank">
      <i class="icon {{ socialLink.icon }}"></i>
      <span>{{ socialLink.title }}</span>
    </a>
  </div>
</div>

<div *ngIf="isMobile" class="links-wrapper mobile">
  <app-expanding-panel title="General">
    <div class="links-list">
      <a *ngFor="let generalLink of generalLinks" class="link" [routerLink]="generalLink.linkUrl" routerLinkActive="is-active">
        <span>{{ generalLink.title }}</span>
      </a>
    </div>
  </app-expanding-panel>

  <app-expanding-panel title="Social">
    <div class="links-list">
      <a *ngFor="let socialLink of socialLinks" class="link" [href]="socialLink.linkUrl" target="_blank">
        <i class="icon {{ socialLink.icon }}"></i>
        <span>{{ socialLink.title }}</span>
      </a>
    </div>
  </app-expanding-panel>
</div>
